import { validateCNPJ, validateCPF } from 'validations-br';
import * as Yup from 'yup';

import { yupResolver } from '@hookform/resolvers/yup';
import { requiredMessage } from './validators';

const requiredString = (name: string) => {
  const message = requiredMessage(name);
  return Yup.string().typeError(message).required(message);
};

const cnpjValidation = Yup.string()
  .nullable()
  .typeError(requiredMessage('CNPJ'))
  .test('is-cnpj', 'CNPJ inválido', (value) => {
    if (value) {
      return validateCNPJ(value as string);
    }

    return true;
  });

const cpfValidation = requiredString('CPF').test(
  'is-cpf',
  'CPF inválido',
  (value: string | undefined) => validateCPF(value as string)
);

const workingStateValidation = Yup.array().test(
  'is-valid-working-state',
  requiredMessage('Estado de atuação'),
  (value) => {
    return Boolean(value?.length);
  }
);

export const representativeValidation = yupResolver(
  Yup.object().shape({
    name: requiredString('Nome'),
    email: requiredString('E-mail').email('E-mail inválido'),
    cpf: cpfValidation,
    cnpj: cnpjValidation,
    mobilePhone: requiredString('Telefone Celular'),
    workingState: workingStateValidation,
  })
);
